import React from "react"
import styled from "styled-components"

const OuterContainer = styled.div`
    max-width: 650px;
    z-index: 3;
    background-color: #f6f6f6;
    position: relative;
    padding: 0 6px;
    margin: 0 auto;
    

    &:before, &:after {
        display: block;
        position: absolute;
        bottom: -9px;
        width: 34px;
        height: 34px;
        background-color: #f6f6f6;
        content: "";

        @media (max-width: 550px) {
            bottom: -6px;
            width: 20px;
            height: 20px;
        }
    }
    
    &:before {
        left: 0px;
        transform: translateX(-50%) translateY(-50%) rotate(45deg);
    }
    
    &:after {
        right: 0px;
        transform: translateX(50%) translateY(-50%) rotate(45deg);
    }

    @media (max-width: 768px) {
        max-width: 480px;
    }

    @media (max-width: 550px) {
        max-width: 280px;
    }
`;

const InnerContainer = styled.div`
    position: relative;
    background-color: #232323;
    z-index: 5;
    padding: 10px 8px;
    font-family: 'Noto Sans JP';
    font-size: 20px;
    font-weight: 900;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 1.2px;
    text-align: center;
    color: #f6f6f6;
    
    &:before, &:after {
        display: block;
        position: absolute;
        z-index: -1;
        bottom: -9px;
        width: 34px;
        height: 34px;
        background-color: #232323;
        content: "";

        @media (max-width: 550px) {
            bottom: -6px;
            width: 20px;
            height: 20px;
        }
    }
    
    &:before {
        left: 0;
        transform: translateX(-50%) translateY(-50%) rotate(45deg);
    }
    
    &:after {
        right: 0px;
        transform: translateX(50%) translateY(-50%) rotate(45deg);
    }

    @media (max-width: 768px) {
        display: flex;
        flex-direction: column;
    }

    @media (max-width: 550px) {
        padding: 5px 0;
        font-size: 12px;
    }
`;

// const Divider = styled.span`
//     @media (max-width: 768px) {
//         display: none;
//     }
// `;

const Duration = () => {
  return (
      <OuterContainer>
        <InnerContainer>
            <span>エントリーは締め切りました。</span>
        </InnerContainer>
      </OuterContainer>
  )
}

Duration.propTypes = {
};

export default Duration;
